



















































import { FindImportacaoUseCase } from '@/usecases'
import CreateRegistroDeCustosUseCase from '@/usecases/custos/CreateRegistroDeCustosUseCase'
import { Component, Vue } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { uploadFilesToS3 } from '@/shareds/s3/files'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'

@Component
export default class DialogoDeCsvCustos extends Vue {
	mostra = false
	importando = false
	arquivoContemCabecalho = false
	arquivoCsv: File | null = null
	findImportacaoUseCase = new FindImportacaoUseCase()
	createRegistroDeCustosUseCase = new CreateRegistroDeCustosUseCase()

	mostrar() {
		this.mostra = true
	}

	cancelar() {
		this.importando = false
		this.mostra = false
		this.arquivoCsv = null
		this.arquivoContemCabecalho = false
	}

	get permiteAbrirDiversosProcessosDeImportacao() {
		if (!UserLoginStore.perfil) return false
		return UserLoginStore.perfil.permissoes.includes('permite-abrir-diversos-processos')
	}

	get usuario() {
		return UserLoginStore.usuario?.id
	}

	async concluirImportacao() {
		if (!this.arquivoCsv) {
			return AlertModule.setError('É obrigatório selecionar um arquivo')
		}

		if (!this.usuario) return

		if (!this.permiteAbrirDiversosProcessosDeImportacao) {
			const possuiProcessoEmAberto = await this.findImportacaoUseCase.possuiImportacoesEmAbertoNoUsuarioLogado(this.usuario)

			if (!possuiProcessoEmAberto) {
				AlertModule.setError('Já existe um processo em aberto para o usuario, aguarde finalizar para prosseguir!')
				this.importando = false
				return
			}
		}

		try {
			this.importando = true

			const informacoesDosArquivos = await uploadFilesToS3(
				[this.arquivoCsv],
				'importacao-de-custos',
			)
			const urlDoArquivoCsv = informacoesDosArquivos.map(({ config }) => config.url)[0]

			if (!urlDoArquivoCsv) {
				return AlertModule.setError('Ocorreu um erro interno, contate o suporte')
			}

			await this.createRegistroDeCustosUseCase.importaCustos(
				urlDoArquivoCsv,
				this.arquivoContemCabecalho,
			)

			AlertModule.setSuccess('Custos em processamento. Acompanhe em Processos.')
			this.cancelar()
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.importando = false
		}
	}

	baixarModelo() {
		const rows = [
			['Loja', 'Produto', 'Chave da nota', 'Número', 'Série', 'Custo fiscal', 'Custo gerencial'],
		]

		const csvContent = 'data:text/csv;charset=utf-8,﻿'
			+ rows.map(e => e.join(';')).join('\n')

		const encodedUri = encodeURI(csvContent)
		const link = document.createElement('a')
		link.setAttribute('href', encodedUri)
		link.setAttribute('download', 'modelo_importacao_custos.csv')
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	}
}
